'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMessageBarBodyContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useMessageBarBodyContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useMessageBarBodyContextValues_unstable(state) {
    const link = _react.useMemo(()=>({
            inline: true
        }), []);
    return {
        link
    };
}
